import React, { useEffect, useState } from 'react';
import ApplicantForm from '../../components/ApplicantForm';
import { useParams, useNavigate } from 'react-router-dom';
import { getApplicantById } from '../../services/applicantService';

const EditApplicant = () => {
  const { id } = useParams(); // Get the applicantId from the URL
  const navigate = useNavigate();
  const [applicant, setApplicant] = useState(null);

  // Fetch the applicant data when the component mounts
  useEffect(() => {
    if (id) {
      getApplicantById(id)
        .then((response) => {
          setApplicant(response.data); // Set the applicant data
        })
        .catch((err) => {
          console.error("Error fetching applicant:", err);
        });
    }
  }, [id]);

  // Log the applicant state
  //useEffect(() => {
  //  console.log('Applicant state:', applicant);
  //}, [applicant]);

  // Handle successful form submission
  const handleSuccess = () => {
    navigate('/applicants/applicantlist'); // Redirect to the applicant list after successful update
  };

  // Show a loading state while fetching the applicant data
  if (!applicant) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <ApplicantForm applicant={applicant} applicantId={id} onSuccess={handleSuccess} />
    </div>
  );
};

export default EditApplicant;